import { Github, Linkedin, Mail } from "lucide-react";

const linkedButtons = [
  { label: "GitHub", href: "https://github.com/flobotdev/", icon: <Github /> },
  {
    label: "LinkedIn",
    href: "https://linkedin.com/in/flobotdev",
    icon: <Linkedin />,
  },
  { label: "Email", href: "mailto:contact@flobot.dev", icon: <Mail /> },
  // { label: "Resume", href: "/resume.pdf", icon: <Document /> } optional
];

export default linkedButtons;
